/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=0f403dfe"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/huanglinhai/Desktop/project/act_marketing/pcauto/g_page_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__